/* AQUON cart empty state: focus placement after the last item is removed.

   When the last line is removed (drawer or /cart page), cart-items.js morphs the
   section and the focused Remove link / quantity button disappears, so focus drops
   to <body> and nothing is announced. This helper waits for that morph, and if the
   cart became empty AND focus was lost, it focuses the "Your cart is empty" heading
   (rendered with tabindex="-1" and [data-aquon-cart-empty-focus]). Moving focus
   there is the announcement; there is no extra live region, so nothing is spoken twice.

   - Listens to the theme's document events only (cart:update fires before the morph,
     cart:updated after it); it never edits cart-items.js or morph.js.
   - Never takes focus from an element that still has it, and does nothing while the
     drawer is closed.
   - Idempotent: included by sections/cart-drawer.liquid and sections/main-cart.liquid,
     and re-run when the theme editor re-renders a section, but registers its two
     listeners once.
   - No MutationObserver and no keydown listener. */
(function () {
  'use strict';

  if (window.AquonCartEmptyA11y) return;

  var FOCUS_SELECTOR = '[data-aquon-cart-empty-focus]';
  // About 1.5 s at 60 fps: covers a morph that first waits on a section fetch.
  var MAX_FRAMES = 90;
  var armed = false;
  var scheduled = false;
  var frames = 0;

  // New item count from CartUpdateEvent / CartAddEvent (detail.data) or cart:updated (detail.cart).
  function countFrom(event) {
    var detail = event && event.detail;
    if (!detail) return null;
    var data = detail.data;
    if (data && typeof data.itemCount === 'number') return data.isIncremental ? null : data.itemCount;
    if (detail.cart && typeof detail.cart.item_count === 'number') return detail.cart.item_count;
    if (detail.resource && typeof detail.resource.item_count === 'number') return detail.resource.item_count;
    return null;
  }

  // A non-empty cart section renders the hidden [ref="cartItemCount"] node.
  function domHasItems() {
    return !!document.querySelector('cart-items-component [ref="cartItemCount"]');
  }

  function focusLost() {
    var active = document.activeElement;
    return !active || active === document.body || active === document.documentElement || !active.isConnected;
  }

  function isShown(el) {
    if (!el.isConnected || !el.getClientRects().length) return false;
    var dialog = el.closest('dialog');
    return !dialog || dialog.open;
  }

  function check() {
    scheduled = false;
    if (!armed) return;
    var nodes = document.querySelectorAll(FOCUS_SELECTOR);
    if (!nodes.length) {
      // The empty-state markup is not in the page yet (morph pending): look again next frame.
      frames += 1;
      if (frames < MAX_FRAMES) schedule();
      else armed = false;
      return;
    }
    // The morph has landed: decide once. A heading inside a closed drawer is not a target.
    armed = false;
    var target = null;
    for (var i = 0; i < nodes.length && !target; i++) {
      if (isShown(nodes[i])) target = nodes[i];
    }
    if (target && focusLost()) target.focus();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(check);
  }

  function onCartChange(event) {
    var count = countFrom(event);
    if (count === null) return;
    if (count > 0) {
      armed = false;
      return;
    }
    // Arm only on a transition: the page still shows items when the "now empty" event arrives.
    if (!armed && domHasItems()) {
      armed = true;
      frames = 0;
    }
    if (armed) schedule();
  }

  document.addEventListener('cart:update', onCartChange);
  document.addEventListener('cart:updated', onCartChange);

  window.AquonCartEmptyA11y = { selector: FOCUS_SELECTOR };
})();
